import {
  getStateBackgroundColor,
  getStateTextColor,
} from "../../modules/jobs/utils";
import { createStateRenderer } from "./State";

const renderer = createStateRenderer(
  getStateTextColor,
  getStateBackgroundColor,
);

export default renderer;
